// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
import { registerShaderModules, setDefaultShaderModules } from 'luma.gl';
import { fp32, fp64, picking } from 'luma.gl';
import project from '../shaderlib/project/project';
import project32 from '../shaderlib/project32/project32';
import project64 from '../shaderlib/project64/project64';
import lighting from '../shaderlib/lighting/lighting';
export function initializeShaderModules() {
  registerShaderModules([fp32, fp64, project, project32, project64, lighting, picking]);
  setDefaultShaderModules([project]);
}
initializeShaderModules();
export { fp32, fp64, picking, project, project64, lighting };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/shaderlib/index.js
// module id = 417
// module chunks = 0